export default {
  admin: {
    title: '出展者一覧',
    deadline: '締切',
    unlockAll: 'すべてロック解除',
    lockAll: 'すべてロック',
    visibleAll: 'すべて表示',
    hiddenAll: 'すべて非表示',
    filter: 'フィルター',
    simpleExtract: '簡易抽出',
    new: '新規',
    status: 'ステータス',
    number: '番号',
    activate: '有効',
    locked: 'ロック済み',
    visible: '表示',
    company: '会社名',
    qrcode: 'QRコード',
    commercialName: '商号',
    year: '年',
    standNumber: 'ブース番号',
    edit: '編集',
    removeExhibitor: '出展者を削除しますか？',
    transmitted: '送信済み',
    saved: '保存済み',
    progress: '進行中',
    pending: '保留中',
    confirm: '確認',
    cancel: 'キャンセル',
    booth: 'ブース',
    hall: 'ホール',
    list_of_users: 'ユーザー一覧',
    role: '役割',
    number_of_authorized_exhibitors: '許可された出展者数',
    number_of_moderators: 'モデレーター数',
    firstname: '名',
    lastname: '姓',
    email: 'メールアドレス',
    create_a_new_moderator: '新しいモデレーターを作成',
    phone: '電話番号',
    exhibitors: '出展者',
    collectif: '共同出展',
    events: 'イベント',
    password: 'パスワード',
  },
};
